// extracted by mini-css-extract-plugin
export default {"span":"Logo_span__eIgka","link":"Logo_link__WDUox"};